import React, { useState } from "react";
import ContentLoader from "../../components/contentLoader";
import Join from "./join";
import styles from "./home.module.scss";
export default function HomePage() {
  return (
    <div>
      <section className={styles.hero}>
        <div className={`contentContainer ${styles.container}`}>
          <div className={styles.heroText}>
            <h1>Run for Their Lives</h1>
            <h2>
              Global run/walk events calling for the immediate release of the
              hostages held by Hamas
            </h2>
          </div>
          <div className={styles.heroImage}></div>
        </div>
      </section>
      <Join />
      <section className={styles.tear}></section>
      <div className="contentContainer">
        <ContentLoader
          docName={"homepage"}
          supportedLangs={["en", "es", "he", "de"]}
        />
      </div>
    </div>
  );
}
